import type { CalendarPeriodMode, CalendarProductId, CalendarProject, CalendarThemeId } from '../types/calendarProject';

type CreateCalendarProjectInput = {
  productId: CalendarProductId;
  periodMode: CalendarPeriodMode;
  year: number;
  startMonth: number;
  themeId: CalendarThemeId;
};

function createProjectId() {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `cs_${crypto.randomUUID()}`;
  }

  return `cs_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

export function createCalendarProject(input: CreateCalendarProjectInput): CalendarProject {
  const now = new Date().toISOString();

  return {
    schemaVersion: '0.1',
    id: createProjectId(),
    createdAt: now,
    updatedAt: now,
    locale: 'cs-CZ',
    currency: 'CZK',
    productId: input.productId,
    period: {
      mode: input.periodMode,
      year: input.year,
      startMonth: input.startMonth,
      monthsCount: 12,
    },
    themeId: input.themeId,
    photos: [],
    pages: [],
    events: [],
    preflight: {
      status: 'not_started',
      issues: [],
    },
    order: {
      status: 'draft',
    },
  };
}
